export default "__VITE_ASSET__46851f0c__"